import React from "react";
import { FaHome, FaChartLine, FaShieldAlt, FaUser, FaPlane, FaBolt } from "react-icons/fa";
import { useLanguage } from "../../context/LanguageContext";

const DubaiVsBudapest = () => {
  const { t } = useLanguage();

  const comparisonData = [
    {
      icon: FaHome,
      category: t("dubaiVsBudapest.categories.realEstate"),
      dubai: {
        value: t("dubaiVsBudapest.dubai.realEstate.value"),
        description: t("dubaiVsBudapest.dubai.realEstate.description")
      },
      budapest: {
        value: t("dubaiVsBudapest.budapest.realEstate.value"),
        description: t("dubaiVsBudapest.budapest.realEstate.description")
      }
    },
    {
      icon: FaChartLine,
      category: t("dubaiVsBudapest.categories.investmentReturn"),
      dubai: {
        value: t("dubaiVsBudapest.dubai.investmentReturn.value"),
        description: t("dubaiVsBudapest.dubai.investmentReturn.description")
      },
      budapest: {
        value: t("dubaiVsBudapest.budapest.investmentReturn.value"),
        description: t("dubaiVsBudapest.budapest.investmentReturn.description")
      }
    },
    {
      icon: FaShieldAlt,
      category: t("dubaiVsBudapest.categories.taxation"),
      dubai: {
        value: t("dubaiVsBudapest.dubai.taxation.value"),
        description: t("dubaiVsBudapest.dubai.taxation.description")
      },
      budapest: {
        value: t("dubaiVsBudapest.budapest.taxation.value"),
        description: t("dubaiVsBudapest.budapest.taxation.description")
      }
    },
    {
      icon: FaUser,
      category: t("dubaiVsBudapest.categories.qualityOfLife"),
      dubai: {
        value: t("dubaiVsBudapest.dubai.qualityOfLife.value"),
        description: t("dubaiVsBudapest.dubai.qualityOfLife.description")
      },
      budapest: {
        value: t("dubaiVsBudapest.budapest.qualityOfLife.value"),
        description: t("dubaiVsBudapest.budapest.qualityOfLife.description")
      }
    },
    {
      icon: FaPlane,
      category: t("dubaiVsBudapest.categories.transportation"),
      dubai: {
        value: t("dubaiVsBudapest.dubai.transportation.value"),
        description: t("dubaiVsBudapest.dubai.transportation.description")
      },
      budapest: {
        value: t("dubaiVsBudapest.budapest.transportation.value"),
        description: t("dubaiVsBudapest.budapest.transportation.description")
      }
    },
    {
      icon: FaBolt,
      category: t("dubaiVsBudapest.categories.futurePotential"),
      dubai: {
        value: t("dubaiVsBudapest.dubai.futurePotential.value"),
        description: t("dubaiVsBudapest.dubai.futurePotential.description")
      },
      budapest: {
        value: t("dubaiVsBudapest.budapest.futurePotential.value"),
        description: t("dubaiVsBudapest.budapest.futurePotential.description")
      }
    }
  ];

  return (
    <section id="dubai-vs-budapest" className="dubai-vs-budapest-area pb-130">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-8">
            <div className="section-title text-center mb-50">
              {/* <span className="sub-title">{t("dubaiVsBudapest.subtitle")}</span> */}
              <h2 className="title text-info">
                {t("dubaiVsBudapest.title")}
              </h2>
              <p className="description text-light mt-4" style={{ fontSize: "1.1rem", lineHeight: "1.6" }}>
                {t("dubaiVsBudapest.description")}
              </p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-12">
            <div 
              className="comparison-table"
              style={{
                backgroundColor: "rgba(33, 37, 41, 0.4)",
                borderRadius: "25px",
                border: "1px solid rgba(255, 255, 255, 0.1)",
                padding: "2rem",
                overflow: "hidden"
              }}
            >
              {/* Table Header */}
              <div 
                className="table-header mb-4"
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  gap: "1rem",
                  paddingBottom: "1rem",
                  borderBottom: "1px solid rgba(255, 255, 255, 0.1)"
                }}
              >
                <div className="text-center">
                  <h4 className="text-white mb-0" style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
                    {t("dubaiVsBudapest.categories.title")}
                  </h4>
                </div>
                <div className="text-center">
                  <h4 className="text-info mb-0" style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
                    Dubai
                  </h4>
                </div>
                <div className="text-center">
                  <h4 className="text-warning mb-0" style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
                    Budapest
                  </h4>
                </div>
              </div>

              {/* Table Rows */}
              {comparisonData.map((item, index) => (
                <div 
                  key={index}
                  className="table-row mb-4"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr",
                    gap: "1rem",
                    alignItems: "start",
                    paddingBottom: index < comparisonData.length - 1 ? "1.5rem" : "0",
                    borderBottom: index < comparisonData.length - 1 ? "1px solid rgba(255, 255, 255, 0.05)" : "none"
                  }}
                >
                  {/* Category */}
                  <div className="category-cell">
                    <div className="d-flex align-items-center">
                      <div 
                        className="category-icon me-3"
                        style={{ fontSize: "1.2rem", color: "#17a2b8" }}
                      >
                        <item.icon />
                      </div>
                      <div>
                        <h5 className="text-white mb-1" style={{ fontSize: "1rem", fontWeight: "600" }}>
                          {item.category}
                        </h5>
                      </div>
                    </div>
                  </div>

                  {/* Dubai */}
                  <div className="dubai-cell">
                    <div 
                      className="city-card"
                      style={{
                        backgroundColor: "rgba(23, 162, 184, 0.1)",
                        borderRadius: "15px",
                        padding: "1rem",
                        border: "1px solid rgba(23, 162, 184, 0.2)"
                      }}
                    >
                      <div 
                        className="value text-info mb-2"
                        style={{ fontSize: "1.1rem", fontWeight: "bold" }}
                      >
                        {item.dubai.value}
                      </div>
                      <div 
                        className="description text-light"
                        style={{ fontSize: "0.85rem", lineHeight: "1.4" }}
                      >
                        {item.dubai.description}
                      </div>
                    </div>
                  </div>

                  {/* Budapest */}
                  <div className="budapest-cell">
                    <div 
                      className="city-card"
                      style={{
                        backgroundColor: "rgba(255, 193, 7, 0.1)",
                        borderRadius: "15px",
                        padding: "1rem",
                        border: "1px solid rgba(255, 193, 7, 0.2)"
                      }}
                    >
                      <div 
                        className="value text-warning mb-2"
                        style={{ fontSize: "1.1rem", fontWeight: "bold" }}
                      >
                        {item.budapest.value}
                      </div>
                      <div 
                        className="description text-light"
                        style={{ fontSize: "0.85rem", lineHeight: "1.4" }}
                      >
                        {item.budapest.description}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Summary Section */}
        <div className="row justify-content-center mt-5">
          <div className="col-lg-10">
            <div className="row">
              {/* Dubai Advantages */}
              <div className="col-lg-6 mb-4">
                <div 
                  className="summary-card"
                  style={{
                    backgroundColor: "rgba(23, 162, 184, 0.1)",
                    borderRadius: "20px",
                    border: "1px solid rgba(23, 162, 184, 0.2)",
                    padding: "1.5rem"
                  }}
                >
                  <h4 className="text-info mb-3" style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
                    {t("dubaiVsBudapest.summary.dubai.title")}
                  </h4>
                  <ul className="list-unstyled mb-0">
                    {t("dubaiVsBudapest.summary.dubai.advantages").map((advantage, index) => (
                      <li key={index} className="text-light mb-2" style={{ fontSize: "0.9rem" }}>
                        • {advantage}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Budapest Advantages */}
              <div className="col-lg-6 mb-4">
                <div 
                  className="summary-card"
                  style={{
                    backgroundColor: "rgba(255, 193, 7, 0.1)",
                    borderRadius: "20px",
                    border: "1px solid rgba(255, 193, 7, 0.2)",
                    padding: "1.5rem"
                  }}
                >
                  <h4 className="text-warning mb-3" style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
                    {t("dubaiVsBudapest.summary.budapest.title")}
                  </h4>
                  <ul className="list-unstyled mb-0">
                    {t("dubaiVsBudapest.summary.budapest.advantages").map((advantage, index) => (
                      <li key={index} className="text-light mb-2" style={{ fontSize: "0.9rem" }}>
                        • {advantage}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DubaiVsBudapest;
